<template>
  <div class="animated container">
    <div class="row justify-content-center">
      <div class="col-md-4 text-center" v-if="resultVerifyDone === false">
        <div class="card">
          <div class="card-header">
            Ověření uživatele
          </div>
          <div class="card-header" v-if="resultInfoDone === true">
            <span>{{ resultInfo.client.anonymised_data }}</span>
          </div>
          <div class="card-body" v-if="resultInfoDone === true">
            <form @submit.prevent="submitAuthForm">
              <div class="form-group">
                <label for="exampleInputPassword1">Heslo</label>
                <input v-model="authForm.password" type="password" class="form-control" id="clientPin" placeholder="Heslo">
                <small id="passwordError" class="form-text text-danger" v-if="resultAuthError">{{ resultAuthError }}</small>
              </div>
              <div class="form-group">
                <template v-if="resultInfo.client.client_auth.help">
                  <span>Nápověda:</span><br>
                  <span><b>{{ resultInfo.client.client_auth.help }}</b></span>
                </template>
                <template v-else="">

                </template>
              </div>
              <button type="submit" id="submitLogin" class="btn btn-primary">Ověřit</button>
            </form>
          </div>
          <div class="card-body" v-if="resultInfoError">
            <span>{{ resultInfoError.lookup_error }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-10" v-else-if="result">
        <div class="card">
          <div class="card-body" v-if="result.evaluation">
            <span><b>Hodnocení lékařem:</b></span><br>
            <pre>{{ result.evaluation }}</pre>
          </div>
          <div class="card-body">
            <span><b>Detalní laboratorní zpráva:</b></span><br>
            <div style="white-space: pre-wrap; font-family: monospace, monospace;" class="p-4" id="result_text" v-html="result.result">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    name: 'dashboard',
    data () {
      return {
        resultInfoPending: false,
        resultInfoError: false,
        resultInfoDone: false,
        resultInfo: false,
        authForm: {
          password: '',
          hash: ''
        },
        resultAuthError: false,
        resultVerifyDone: false,
        resultVerifyPending: false,
        resultVerifyError: false,
        result: ''
      }
    },
    mixins: [apiMixin],
    methods: {
      test () {
        this.pinExpTime = true
      },
      loadResultInfo () {
        this.getResultInfo(this.$route.query.h)
      },
      submitAuthForm () {
        this.authForm.hash = this.$route.query.h
        this.postResultVerify(this.authForm)
        // this.authLogin({params: {}, data: {username: this.user.username, password: this.user.password}})
      }
    },
    beforeMount () {
      this.loadResultInfo()
    },
    mounted () {
      // console.log(this.$route)
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/ClientSide/Result.vue?c9426d1a